export default "__VITE_ASSET__bb31db8f__"